import { Box, Stack, Typography } from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import { Outlet } from 'react-router-dom';
import { config } from '../../config';

export default function AuthLayout() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // background:
        //   'linear-gradient(135deg, #5b5bd6 0%, #7c3aed 50%, #da00ff 100%)',
        p: 2,
      }}
    >
      <Stack spacing={3} alignItems="center" sx={{ width: '100%', maxWidth: 440 }}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              bgcolor: 'rgba(255,255,255,0.15)',
              borderRadius: 2,
              p: 1,
              display: 'flex',
            }}
          >
            <TranslateIcon sx={{  fontSize: 32 }} />
          </Box>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            {config.appName}
          </Typography>
        </Stack>
        <Outlet />
      </Stack>
    </Box>
  );
}
